import React from "react";
import * as UIcons from "@iconscout/react-unicons";
import LinkItem from "components/Link";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Review, Vault, Credit, GamePad } from "assets/icons";

import usePermissions from "hooks/usePermissions";
import { TbUsers } from "react-icons/tb";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

export default withTranslation()(function Sidebar({ t }) {
  const { sidebar } = useSelector((state) => state.misc);

  const { isPermitted } = usePermissions();
  const pathname = window.location.pathname;
  const navLinks = [
    {
      url: `/${t("sidenav.overview").toLowerCase()}`,
      Icon: UIcons.UilApps,
      show: isPermitted?.view_all_overview,
      label: t("sidenav.overview"),
    },
    {
      url: `/${t("sidenav.transactions").toLowerCase()}`,
      Icon: UIcons.UilExchange,
      show: isPermitted?.view_all_transactions,
      label: t("sidenav.transactions"),
    },
    {
      url: `/${t("sidenav.totalCustomers").toLowerCase()}`,
      Icon: ({ className }) => <TbUsers className={className} size={30} />,
      show: isPermitted?.view_all_transactions,
      label: t("sidenav.customers"),
    },
    {
      url: `/${t("sidenav.vault").toLowerCase().replace(" ", "-")}`,
      Icon: ({ className }) => <Vault classList={className} />,
      show: isPermitted?.view_all_transactions,
      label: t("sidenav.vault"),
    },
    {
      // url: `/${ t("sidenav.promo").toL`owerCase() }`,
      url: `/${t("sidenav.campaignlink").toLowerCase()}`,
      // url: `#`,
      Icon: UIcons.UilPercentage,
      show: isPermitted?.view_all_promos,
      label: t("sidenav.promo"),
      children: [
        {
          // url: `/${t("sidenav.campaign").toLowerCase()}`,
          url: `/${t("sidenav.campaignlink").toLowerCase()}`,
          Icon: UIcons.UilMegaphone,
          show: isPermitted?.view_all_promos,
          label: t("sidenav.campaign"),
        },
        {
          url: `/promo/games`,
          Icon: ({ className }) => <GamePad classList={className} />,
          show: isPermitted?.view_all_promos,
          label: t("sidenav.games"),
        },
      ],
    },
    {
      url: `/${t("sidenav.credit").toLowerCase()}`,
      Icon: ({ className }) => <Credit classList={className} />,
      show: isPermitted?.view_all_transactions,
      label: t("sidenav.credit"),
    },
    {
      url: `/deposits`,
      Icon: UIcons.UilMoneyBill,
      show: true,
      label: "Deposits",
    },
    {
      url: `/cash-flow`,
      Icon: UIcons.UilGraphBar,
      show: true,
      label: "Cash Flow",
    },
    {
      url: `/movie-box`,
      Icon: UIcons.UilFilm,
      show:true,
      label: "MovieBox",
    },

    {
      url: `/${t("sidenav.pos").toLowerCase()}`,
      Icon: UIcons.UilMobileAndroidAlt,
      show: isPermitted?.view_pos,
      label: t("sidenav.pos"),
    },
    {
      url: `/${t("sidenav.review").toLowerCase()}`,
      Icon: ({ className }) => <Review classList={className} />,
      show: isPermitted?.view_all_reviews,
      label: t("sidenav.review"),
    },
    // {
    //   url: `/${ t("sidenav.settlements").toLowerCase() }`,
    //   Icon: UIcons.UilMoneyBill,
    //  show:true,
    //   label: t("sidenav.settlements"),
    // },
    {
      url: `/${t("sidenav.settings").toLowerCase()}/business-info`,
      Icon: UIcons.UilSetting,
      show: true,
      label: t("sidenav.settings"),
    },
  ];
  const navigate = useNavigate();

  //  ${sidebar ? 'left-0' : '-left-64 md:-left-44'}
  return (
    <div
      className={`trans fixed top-14 md:top-16 left-0 z-[1000] h-screen w-64 bg-white shadow-sm  ${
        sidebar ? "left-0" : "-left-64 md:-left-44"
      }`}
    >
      <ul className="w-full py-3 relative z-[1000]">
        {navLinks.map((link) => {
          const { url, Icon, label, show, children } = link;
          const DropIcon = () =>
            children.find((child) => child.url === pathname) ? (
              <BsChevronUp
                fontWeight={600}
                style={{ justifySelf: "right" }}
                className="absolute right-10 order-3"
              />
            ) : (
              <BsChevronDown
                fontWeight={600}
                style={{ justifySelf: "right" }}
                className="absolute right-10 order-3"
              />
            );

          return (
            <li className={`${!show && "hidden"}`} key={url}>
              <LinkItem
                onClick={children ? () => navigate(link.url) : null}
                key={url}
                url={url}
                dropicon={children && sidebar}
                classList={`w-full py-5 px-5 text-lg ${
                  sidebar ? "inline-block" : "flex justify-between items-center"
                }  ${
                  url.split("/")[1] === pathname.split("/")[1]
                    ? "text-primary bg-focus font-semibold border-l-4 border-primary"
                    : "text-body-text"
                }`}
                tag={() => (
                  <div
                    className={`flex ${
                      sidebar ? "" : "justify-between "
                    } w-full  items-center`}
                  >
                    {/* <div> */}
                    <Icon
                      className={`p-1 rounded-md inline-block mr-2 ${
                        label === t("sidenav.vault") ? "h-8 w-8" : ""
                      } ${sidebar ? "order-1" : "order-2"} ${
                        label === "Transactions" ? "rotate-90" : ""
                      } ${
                        url.split("/")[1] === pathname.split("/")[1]
                          ? "bg-icon-focus text-primary"
                          : "bg-icon-bg text-body-text"
                      }`}
                      size={30}
                    />
                    {
                      <span
                        className={`${
                          sidebar ? "order-2 self-right" : "order-1"
                        }`}
                      >
                        {label}
                      </span>
                    }
                    {/* </div> */}
                    {children && sidebar && <DropIcon />}
                  </div>
                )}
              />
              {children &&
                children.find((child) => child.url === pathname) &&
                children.map(({ url, Icon, label, show, children }) => (
                  <LinkItem
                    key={url}
                    url={url}
                    classList={`w-full py-2 px-5 text-lg  ${
                      sidebar
                        ? "inline-block"
                        : "flex justify-between items-center"
                    }  ${
                      url.split("/")[2] === pathname.split("/")[2]
                        ? "text-primary bg-focus font-semibold border-l-4 border-primary"
                        : "text-body-text"
                    }`}
                    tag={() => (
                      <>
                        <Icon
                          className={`p-1 rounded-md inline-block ml-4 mr-2 ${
                            label === t("sidenav.vault") ? "h-8 w-8" : ""
                          } ${sidebar ? "order-1" : "order-2"} ${
                            label === "Transactions" ? "rotate-90" : ""
                          } ${
                            url.includes(pathname)
                              ? "bg-icon-focus text-primary"
                              : "bg-icon-bg text-body-text"
                          }`}
                          size={30}
                        />
                        <span className={`${sidebar ? "order-2" : "order-1"}`}>
                          {label}
                        </span>
                      </>
                    )}
                  />
                ))}
            </li>
          );
        })}
      </ul>
    </div>
  );
});
